module.exports = __webpack_public_path__ + "img/clients-itinerary.be97f24c.svg";